import { gql } from '@apollo/client';

// ── Queries ──────────────────────────────────────────────────────────────────

export const GET_OATT_REVISION_DATA = gql`
  query GetOattRevisionData($month: Int!, $year: Int!, $revisionNo: Int!, $customerId: Int) {
    oattRevisionData(month: $month, year: $year, revisionNo: $revisionNo, customerId: $customerId) {
      oatt_data_id
      seller
      aref
      customer_code
      billing_period
      start_time
      stop_time
      mw_granted
      billing_rate
      billing_type
      ts_class
      increment
      ts_type
      ts_window
      hours
      net_trans
      asr_rv_net
      asr_sc_net
      total_charges
      is_revision
      revision_no
      changes_from_original
      # True when all oatt_computed records for this revision are approved.
      # Backend: JOIN oatt_computed ON revision_no/month/year/customer_id,
      #          return TRUE only when every matching row has approval = true.
      revision_approved
    }
  }
`;

export const GET_OATT_REVISION_NUMBERS = gql`
  query GetOattRevisionNumbers($month: Int!, $year: Int!, $customerId: Int) {
    oattRevisionNumbers(month: $month, year: $year, customerId: $customerId)
  }
`;

/**
 * Ancillary rates from oatt_rates config table.
 * Used for live-preview calculation of asr_sc_net / asr_rv_net in the revision page.
 */
export const GET_OATT_ANCILLARY_RATES = gql`
  query GetOattAncillaryRates {
    getOattAncillaryRates {
      ancillary_service_type
      frequency
      rate
    }
  }
`;

// ── Mutations ────────────────────────────────────────────────────────────────

export const CREATE_OATT_REVISION = gql`
  mutation CreateOattRevision($month: Int!, $year: Int!, $customerId: Int) {
    createOattRevision(month: $month, year: $year, customerId: $customerId) {
      success
      message
      count
      revision_no
    }
  }
`;
export const SAVE_OATT_REVISION = gql`
  mutation SaveOattRevision(
    $records: [OattRevisionRecordInput!]!,
    $customerId: Int!
  ) {
    saveOattRevision(
      records: $records,
      customerId: $customerId
    ) {
      success
      message
    }
  }
`;